import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'v1/message-groups'
const plural = 'messageGroups'
const single = 'messageGroup'

const messageGroups = new ApiCore({
	index: true,
	url: url,
	plural: plural,
	single: single
})

messageGroups.export = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/v1/local/exportMessages`, payload)
		.then(handleResponse)
		.catch(handleError);
}

export default messageGroups
